export const RHI_QUERY_KEYS = {
  CREATE_LEAD: 'createLead',
  GET_RHI_LEADS: 'getRHILeads',
  UPDATE_LEAD: 'updateLead',
  GET_CONFIG: 'getConfig',
  RETAIL_HEALTH_INSURANCE_QUOTES: 'retail-health-insurance-quotes',
  GENERATE_QUOTE: 'generateQuote',
  CREATE_RHI_V2_QUOTE: 'createRhiV2Quote',
  GET_RHI_V2_QUOTE: 'getRhiV2Quote',
  GET_RHI_V2_SELECTION: 'getRhiV2Selection',
  UPDATE_RHI_V2_SELECTION: 'updateRhiV2Selection',
  COMMIT_RHI_V2_SELECTION: 'commitRhiV2Selection',
  GET_RHI_V2_PROPOSAL_QUESTIONS: 'getRhiV2ProposalQuestions',
  SAVE_RHI_V2_PROPOSAL_ANSWERS: 'saveRhiV2ProposalAnswers',
  UPLOAD_RHI_V2_PROPOSAL_DOCUMENT: 'uploadRhiV2ProposalDocument',
  AFFIRM_RHI_V2_PROPOSAL: 'affirmRhiV2Proposal',
  SUBMIT_RHI_V2_PROPOSAL: 'submitRhiV2Proposal',
  SEND_RHI_V2_PROPOSAL_FOR_REVIEW: 'sendRhiV2ProposalForReview',
  GET_RHI_V2_PAYMENT_SUMMARY: 'getRhiV2PaymentSummary',
  INITIATE_RHI_V2_PAYMENT: 'initiateRhiV2Payment',
  GET_RHI_V2_PAYMENT_STATUS: 'getRhiV2PaymentStatus',
  GET_RHI_V2_POLICY_DOCUMENT: 'getRhiV2PolicyDocument',
  GET_RHI_V2_KYC_FORM: 'getRhiV2KycForm',
  INITIATE_RHI_V2_KYC: 'initiateRhiV2Kyc',
  VERIFY_RHI_V2_KYC_OTP: 'verifyRhiV2KycOtp',
  GET_RHI_V2_KYC_STATE: 'getRhiV2KycState',
  ACCEPT_RHI_V2_KYC_PRICE: 'acceptRhiV2KycPrice',
  GET_RHI_V2_PINCODE: 'getRhiV2Pincode',
  GET_RHI_V2_IFSC: 'getRhiV2Ifsc',
  GENERATE_PURCHASE_INTENT: 'generatePurchaseIntent',
  GET_MEDICAL_QUESTIONS: 'getMedicalQuestions',
  SUBMIT_MEDICAL_QUESTIONS: 'submitMedicalQuestions',
  CREATE_OTP: 'createOtp',
  VERIFY_OTP: 'verifyOtp',
  ADD_NOMINEE: 'addNominee',
  ADD_BANK_DETAILS: 'addBankDetails',
  GET_PROPOSAL: 'getProposal',
  GET_POLICY_STATUS: 'getPolicyStatus',
  PAYMENT_CALLBACK: 'paymentCallback',
  CREATE_SUPERLEAP_LEAD: 'createSuperleapLead',
  CREATE_SUPERLEAP_OPPORTUNITY: 'createSuperleapOpportunity',
  GET_RHI_V2_JOURNEY_LIST: 'getRhiV2JourneyList',
  PERSIST: 'persist',
} as const;

export const RHI_SESSION_KEYS = {
  BENEFIT_ID: 'rhi-benefit-id',
  LEAD_ID: 'rhi-lead-id',
  QUOTE_ID: 'rhi-quote-id',
  QUOTE_REQUEST: 'rhi-quote-request',
  EFFECTIVE_PARAMS: 'rhi-effective-params',
  SELECTED_PLAN_ID: 'rhi-selected-plan-id',
  SELECTED_MEMBERS: 'rhi-selected-members',
  SELECTED_MEMBERS_FORM: 'rhi-selected-members-form-v2',
  SELECTED_SUM_INSURED: 'rhi-selected-sum-insured',
  ESSENTIAL_RIDERS: 'rhi-essential-riders',
  PROPOSER_FORM: 'rhi-proposer-form',
  NOMINEE_FORM: 'rhi-nominee-form',
  BANK_DETAILS_FORM: 'rhi-bank-details-form',
  PROPOSAL_ID: 'rhi-proposal-id',
  CARRIED_PLAN_ID: 'rhi-carried-plan-id',
  PROPOSAL_FORM: 'rhi-proposal-form',
  EKYC_RESEND_COUNT: 'rhi-ekyc-resend-count',
  KYC_RESEND_COUNT: 'rhi-v2-kyc-resend-count',
  POST_PAYMENT_PENDING_START_TIME: 'rhi-post-payment-start',
  SUPERLEAP_LEAD_CREATED: 'rhi-superleap-lead-created',
  /** The history entry a resume left from, and where going back to it should land. */
  RESUME_RETURN: 'rhi-resume-return',
} as const;

/** BroadcastChannel name for payment status (not a sessionStorage key). */
export const RHI_BROADCAST_CHANNEL_NAME = 'rhi-payment-status';

export const RHI_TTL_VALUES = {
  SELECTED_MEMBERS: 10 * 60 * 1000, // 10 minutes
  HEALTH_INSURANCE_FORMS: 10 * 1000, // 10 seconds
  SUPERLEAP_LEAD: 24 * 60 * 60 * 1000, // 24 hours
  RHI_V2_PINCODE: 24 * 60 * 60 * 1000, // 24 hours, the server's max-age
  RHI_V2_IFSC: 24 * 60 * 60 * 1000, // 24 hours, the server's max-age
} as const;


export const RHI_TIMEOUT_VALUES = {
  PENDING_TIMEOUT_MS: 10 * 60 * 1000, // 10 minutes
  CONFIRMING_TIMEOUT_MS: 15 * 1000, // 15 seconds
  AWAITING_POLICY_TIMEOUT_MS: 2 * 60 * 1000, // 2 minutes
  SUCCESS_REDIRECT_TIMEOUT_MS: 12 * 1000, // 12 seconds
  POLICY_STATUS_POLLING_INTERVAL_MS: 5 * 1000, // 5 seconds
  RHI_V2_QUOTE_POLL_INTERVAL_MS: 3 * 1000, // 3 seconds
  RHI_V2_QUOTE_POLL_TIMEOUT_MS: 60 * 1000, // 60 seconds
  AGENT_SESSION_WARNING_LEAD_MS: 15 * 60 * 1000, // 15 minutes
  RHI_V2_PAYMENT_POLL_INTERVAL_MS: 4 * 1000, // 4 seconds
  RHI_V2_PAYMENT_POLL_CEILING_MS: 2 * 60 * 1000, // 2 minutes
} as const;

export const RHI_CALLBACK_VALUES = {
  CALLBACK_RETRY_DELAY_MS: 5000, // 5 seconds
} as const;